// Single event-emitter for marketing/analytics tracking.
//
// Every conversion-worthy action in the app pushes through `trackEvent`.
// Events land on `window.dataLayer` and are picked up by whatever tag manager
// is loaded in public/index.html (currently Google Tag Manager).
//
// See frontend/MARKETING.md for the full event catalog and the day-1 GTM
// setup checklist.

/**
 * Names of every event the app emits. Treat this as the public contract with
 * the marketing/analytics layer — renaming a value here breaks GTM triggers.
 */
export const TRACKED_EVENTS = {
  SIGNUP_COMPLETED: 'signup_completed',
  SIGNUP_GOOGLE_COMPLETED: 'signup_google_completed',
  EMAIL_VERIFIED: 'email_verified',
  LOGIN_COMPLETED: 'login_completed',
  CONVERSION_STARTED: 'conversion_started',
  CONVERSION_SUCCEEDED: 'conversion_succeeded',
  CHECKOUT_STARTED: 'checkout_started',
  SUBSCRIBE_COMPLETED: 'subscribe_completed',
  PLAN_CHANGED: 'plan_changed',
  SUBSCRIPTION_CANCELED: 'subscription_canceled',
};

/**
 * Push an event to window.dataLayer. No-ops if dataLayer isn't loaded
 * (e.g. when REACT_APP_GTM_ID is unset, or in test environments).
 *
 * @param {string} name   One of TRACKED_EVENTS.
 * @param {object} [params]  Optional payload. Keys appear on the event object
 *                           and are referenceable in GTM as dataLayer
 *                           variables.
 */
export function trackEvent(name, params = {}) {
  if (typeof window === 'undefined') return;
  if (!Array.isArray(window.dataLayer)) return;
  window.dataLayer.push({ event: name, ...params });
}
